import type { Dish } from "@dashboard/types/dish";
import type { ReduxState } from "@dashboard/types/reduxState";

import { RestaurantChangedAction } from "./restaurantReducer";

export type DishReducerAction =
  | RestaurantChangedAction
  | { type: "FETCHED_DISHES"; payload: Dish[] };

export const dishReducer: (
  state: ReduxState["dish"] | undefined,
  action: DishReducerAction
) => ReduxState["dish"] = (
  state: ReduxState["dish"] = {
    initialDishesLoading: true,
    dishes: [],
  },
  action: DishReducerAction
) => {
  switch (action.type) {
    case "RESTAURANT_CHANGED":
      return {
        ...state,
        initialDishesLoading: true,
      };
    case "FETCHED_DISHES":
      return {
        ...state,
        initialDishesLoading: false,
        dishes: action.payload,
      };
    default:
      return state;
  }
};
